export const WIDGET_PADDING = 3 // need to modify
export const WIDGET_SCALE_SQUARE_BORDER_WIDTH = 1
export const CONTAINER_PADDING = 4
export const DEFAULT_MIN_COLUMN = 1
export const LIKE_CONTAINER_WIDGET_PADDING = 4
export const LIST_ITEM_MARGIN_TOP = 8
export const LABEL_TOP_UNIT_HEIGHT = 32
export const VALIDATE_MESSAGE_HEIGHT = 33
